import { useState, useEffect, useCallback } from "react";
import type { Apoio } from "@/types";
import { dbGet, dbSet } from "@/lib/db";
import { SK } from "@/lib/constants";

export function useApoios() {
  const [apoios, setApoios] = useState<Apoio[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dbGet<Apoio[]>(SK.APOIOS).then((a) => {
      setApoios(a ?? []);
      setLoading(false);
    });
  }, []);

  const persist = useCallback((next: Apoio[]) => {
    setApoios(next);
    dbSet(SK.APOIOS, next);
  }, []);

  const addApoio = useCallback(
    (apoio: Omit<Apoio, "id">) => {
      const newApoio: Apoio = { ...apoio, id: "A" + Date.now() };
      persist([...apoios, newApoio]);
      return newApoio;
    },
    [apoios, persist]
  );

  const updateApoio = useCallback(
    (id: string, updates: Partial<Apoio>) => {
      persist(apoios.map((a) => (a.id === id ? { ...a, ...updates } : a)));
    },
    [apoios, persist]
  );

  const deleteApoio = useCallback(
    (id: string) => {
      persist(apoios.filter((a) => a.id !== id));
    },
    [apoios, persist]
  );

  const setAllApoios = useCallback(
    (a: Apoio[]) => persist(a),
    [persist]
  );

  return { apoios, loading, addApoio, updateApoio, deleteApoio, setAllApoios };
}
